import { Component, Input, OnInit } from '@angular/core';
import {
  Prices,
  PurchaseFlowService,
  TileBlocks,
} from '../../../services/purchase-flow.service';
import { Point } from '../../../common/types/size';
import { Events } from '../../wall/events';
import { EventKey } from '../../../common/enums/event-key';
import { BaseComponent } from '../../../common/base/base.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss'],
})
export class TilesComponent extends BaseComponent implements OnInit {
  @Input() public tilesSize: number = 4;

  public tileBlocks!: TileBlock[];
  public selectedBlock: TileBlock | undefined;
  public prices$: Observable<Prices> | undefined;

  constructor(private purchaseFlowService: PurchaseFlowService) {
    super();
  }

  ngOnInit(): void {
    this.tileBlocks = TileBlocks;
    if (this.purchaseFlowService.pillSize) {
      this.selectBlock(
        this.tileBlocks.find(
          (block) => block.size.x === this.purchaseFlowService.pillSize?.x
        ) as TileBlock
      );
      this.prices$ = this.purchaseFlowService.getPrices(
        this.purchaseFlowService.pillSize?.x
      );
    } else {
      this.selectedBlock = this.tileBlocks[0];
      this.prices$ = this.purchaseFlowService.getPrices(1);
    }
  }

  public handleBlockSelect(block: TileBlock, index: number): void {
    if (
      block.size.x === this.selectedBlock?.size?.x ||
      index >= this.tilesSize
    ) {
      return;
    }
    this.selectBlock(block);
  }

  private selectBlock(block: TileBlock) {
    this.selectedBlock = block;
    this.purchaseFlowService.pillSize = block.size;
    this.prices$ = this.purchaseFlowService.getPrices(block.size.x);
    Events.emit({ key: EventKey.TileSizeClick, data: block.size });
  }
}

interface TileBlock {
  size: Point;
}
